import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext.jsx'
import ProtectedRoute from './auth/ProtectedRoute.jsx'
import { ThemeProvider } from './theme/ThemeContext.jsx'
import { ShowSqlProvider } from './settings/ShowSqlContext.jsx'
import Layout from './components/Layout.jsx'
import Dashboard from './components/Dashboard.jsx'
import AnalyticsPage from './components/AnalyticsPage.jsx'
import ConnectorsPage from './components/ConnectorsPage.jsx'
import LakePage from './components/LakePage.jsx'
import SettingsPage from './components/SettingsPage.jsx'
import LoginPage from './components/LoginPage.jsx'

export default function App() {
  return (
    <ThemeProvider>
    <ShowSqlProvider>
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={
          <ProtectedRoute>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard"  element={<Dashboard />} />
                <Route path="analytics"  element={<AnalyticsPage />} />
                <Route path="connectors" element={<ConnectorsPage />} />
                <Route path="lake"       element={<LakePage />} />
                <Route path="settings"   element={<SettingsPage />} />
              </Route>
            </Routes>
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
    </ShowSqlProvider>
    </ThemeProvider>
  )
}
